import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { useDidMount } from "rooks";
import { useFlag } from "@unleash/proxy-client-react";
import { useAppDispatch } from "@/store/hooks";
import { setCommitmentsDataViewTab } from "@/store/commitments/commitmentsSlice";
import { ReservationsRecommendationsOverviewDataGrid } from "@/components/pages/commtiments/reservations/components/content/recomendations/ReservationsRecommendationsOverviewDataGrid";
import { SavingPlansRecommendationsOverviewDataGrid } from "@/components/pages/commtiments/utilization-and-coverage/components/content/recommendations/SavingPlansRecommendationsOverviewDataGrid";

export const CommitmentsOverviewRecommendations: FC = () => {
  const enableReservationRecommendation = useFlag(
    "EnableReservationRecommendation",
  );
  const dispatch = useAppDispatch();

  useDidMount(() => {
    dispatch(setCommitmentsDataViewTab("saving_plans"));
  });

  return (
    <Stack pt={1} height="100%">
      <Typography variant="h6" fontWeight="bold" pl={1} pb={1}>
        Recommendations
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap" height="100%">
        <SavingPlansRecommendationsOverviewDataGrid />
        {enableReservationRecommendation && (
          <ReservationsRecommendationsOverviewDataGrid />
        )}
      </Stack>
    </Stack>
  );
};
